// <copyright file="api-version.service.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 11/28/2025 by Pankaj Mishra
// </copyright>

import { Injectable } from "@angular/core";
import { ApiVersionConfig } from "./api-version-config.model";
import { environment } from "../../../environments/environment";
import { fallbackApiVerion } from "../../../assets/data/apiconstant";

@Injectable({
  providedIn: "root"
})

// Defines ApiVersionService.
export class ApiVersionService {
  private readonly config: ApiVersionConfig = {
    version: environment.appEndPointVersion,
    fallBackVersion: fallbackApiVerion
  };
  getVersion(): string {
    return this.config.version || this.config.fallBackVersion;
  }
  setVersion(version: string): void {
    this.config.version = version;
  }
}
